import { render, staticRenderFns } from "./HeaderRecapSottoscrizioniPaziente.vue?vue&type=template&id=045cfbb6&scoped=true"
import script from "./HeaderRecapSottoscrizioniPaziente.vue?vue&type=script&lang=js"
export * from "./HeaderRecapSottoscrizioniPaziente.vue?vue&type=script&lang=js"
import style0 from "./HeaderRecapSottoscrizioniPaziente.vue?vue&type=style&index=0&id=045cfbb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045cfbb6",
  null
  
)

export default component.exports